import React from 'react';
import { assetPrefix } from '../../../utils/assetPrefix';
import { Button } from '../../shared/Button';
import { Container } from '../../shared/Container';

export const Header = () => {
    return (
        <header className="c-header">
            <Container extraClass="header__container">
                <a className="header__logo" href="https://www.hypotheker.nl/">
                    <img src={`${assetPrefix}/assets/svg/logo-no-text-40-year.svg`} alt="De Hypotheker logo" />
                </a>

                <div className="header__buttons">
                    <Button
                        url="https://www.hypotheker.nl/vestigingen/"
                        label="Vestigingen"
                        variant="ghost"
                        extraClasses="header__button-vestigingen"
                    />
                    <Button
                        url="https://www.hypotheker.nl/afspraak-maken-hypotheekadviseur/"
                        label="Afspraak maken"
                        variant="tertiary"
                    />
                </div>
            </Container>
        </header>
    );
};
